import { __assign, __awaiter, __generator, __extends } from 'tslib';
import { Injectable, ɵɵdefineInjectable, ɵɵinject, Component, forwardRef, EventEmitter, ComponentFactoryResolver, ApplicationRef, Injector, NgZone, Input, NgModule } from '@angular/core';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { OktaAuthService, OKTA_CONFIG, OktaAuthModule } from '@okta/okta-angular';
import { DocumentInterruptSource, Idle } from '@ng-idle/core';
import { BehaviorSubject, Observable, fromEvent } from 'rxjs';
import { filter } from 'rxjs/operators';
import { CommonModule, LOCATION_INITIALIZED } from '@angular/common';
import { Keepalive } from '@ng-idle/keepalive';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function AppSettings() { }
if (false) {
    /** @type {?|undefined} */
    AppSettings.prototype.oktaConfiguration;
}
var AppSettingsService = /** @class */ (function () {
    function AppSettingsService() {
        this.settingsSource = new BehaviorSubject({
            oktaConfiguration: undefined
        });
        this.settings = this.settingsSource.asObservable();
    }
    /**
     * @param {?} settings
     * @return {?}
     */
    AppSettingsService.prototype.setSettings = /**
     * @param {?} settings
     * @return {?}
     */
    function (settings) {
        console.log('in app settings service setting configs at:', new Date().toLocaleString());
        console.log(settings);
        /** @type {?} */
        var updatedConfig = __assign(__assign({}, this.settingsSource.value), settings);
        this.settingsSource.next(updatedConfig);
    };
    /**
     * @return {?}
     */
    AppSettingsService.prototype.getSettings = /**
     * @return {?}
     */
    function () {
        return this.settingsSource.value;
    };
    AppSettingsService.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root'
                },] }
    ];
    /** @nocollapse */
    AppSettingsService.ctorParameters = function () { return []; };
    /** @nocollapse */ AppSettingsService.ɵprov = ɵɵdefineInjectable({ factory: function AppSettingsService_Factory() { return new AppSettingsService(); }, token: AppSettingsService, providedIn: "root" });
    return AppSettingsService;
}());
if (false) {
    /** @type {?} */
    AppSettingsService.prototype.settings;
    /**
     * @type {?}
     * @private
     */
    AppSettingsService.prototype.settingsSource;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function SnOktaConfig() { }
if (false) {
    /**
     * Okta Client Id
     * @type {?|undefined}
     */
    SnOktaConfig.prototype.clientId;
    /**
     * Okta issuer authentication server
     * @type {?|undefined}
     */
    SnOktaConfig.prototype.issuer;
    /**
     * Url to redirect to, typically /implicit/callback
     * @type {?|undefined}
     */
    SnOktaConfig.prototype.redirectUri;
    /**
     * Array of scopes, ie 'openid', 'profile', 'email'
     * @type {?|undefined}
     */
    SnOktaConfig.prototype.scopes;
}
/**
 * Library configuration
 * @record
 */
function Config() { }
if (false) {
    /**
     * Root for the DaaS API
     * @type {?}
     */
    Config.prototype.apiRoot;
    /**
     * DaaS Audience header
     * @type {?|undefined}
     */
    Config.prototype.audience;
    /**
     * DaaS x-source-description header
     * @type {?|undefined}
     */
    Config.prototype.sourceDescription;
    /** @type {?|undefined} */
    Config.prototype.oktaConfiguration;
}
/**
 * @ignore
 */
var ConfigProvider = /** @class */ (function () {
    function ConfigProvider(appSettingsService) {
        this.appSettingsService = appSettingsService;
    }
    /**
     * @param {?} config
     * @return {?}
     */
    ConfigProvider.prototype.setConfig = /**
     * @param {?} config
     * @return {?}
     */
    function (config) {
        console.log('in serenity ConfigProvider');
        ConfigProvider.config = config;
        this.appSettingsService.setSettings({
            oktaConfiguration: config.oktaConfiguration
        });
    };
    ConfigProvider.config = {};
    ConfigProvider.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root'
                },] }
    ];
    /** @nocollapse */
    ConfigProvider.ctorParameters = function () { return [
        { type: AppSettingsService }
    ]; };
    /** @nocollapse */ ConfigProvider.ɵprov = ɵɵdefineInjectable({ factory: function ConfigProvider_Factory() { return new ConfigProvider(ɵɵinject(AppSettingsService)); }, token: ConfigProvider, providedIn: "root" });
    return ConfigProvider;
}());
if (false) {
    /** @type {?} */
    ConfigProvider.config;
    /**
     * @type {?}
     * @private
     */
    ConfigProvider.prototype.appSettingsService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @ignore
 */
var SnAuthWorkingComponent = /** @class */ (function () {
    function SnAuthWorkingComponent() {
    }
    SnAuthWorkingComponent.decorators = [
        { type: Component, args: [{
                    selector: 'sn-auth-working',
                    template: "\n        <div class=\"cover\"><i class=\"fas fa-circle-notch fa-spin\"></i></div>\n    ",
                    styles: ["\n            .cover {\n                position: fixed;\n                width: 100%;\n                height: 100%;\n                left: 0;\n                top: 0;\n                color: #fff;\n                background: #007bff;\n                z-index: 2147483647;\n                display: flex;\n                justify-content: center;\n                align-items: center;\n                font-size: 90px;\n            }\n        "]
                }] }
    ];
    return SnAuthWorkingComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @ignore
 * @type {?}
 */
var config = forwardRef((/**
 * @return {?}
 */
function () { return ConfigProvider.config; }));
/**
 * @ignore
 * 8 hours, formerly defaultSessionLength (seconds)
 * @type {?}
 */
var defaultIdleLength = 8 * 60 * 60;
/**
 * @ignore
 * Set to non zero to specify a shorter renew (seconds)
 * @type {?}
 */
var diagnosticShortTokenLife = 0;
/**
 * @ignore
 * Refresh before expiration  (seconds)
 * @type {?}
 */
var tokenRefreshBeforeExpiration = 10 * 60;
/**
 * @ignore
 * A random window between set time of refresh - (tokenRefreshBeforeExpiration+tokenRefreshRandomWindow must be  less than expiration window)   (secnds)
 * @type {?}
 */
var tokenRefreshRandomWindow = 5 * 60;
var SnAuthService = /** @class */ (function () {
    function SnAuthService(okta, idle, http, componentFactoryResolver, appRef, injector, ngZone) {
        var _this = this;
        this.okta = okta;
        this.idle = idle;
        this.http = http;
        this.componentFactoryResolver = componentFactoryResolver;
        this.appRef = appRef;
        this.injector = injector;
        this.ngZone = ngZone;
        /**
         * Event emitters for all auth-related events
         *
         * |Event|Description|
         * |----|----|
         * |onTimeout|Inherited from `\@ng-idle/core`.  Fired on session timeout, when the user will be logged out.|
         * |onTimeoutWarning|Inherited from `\@ng-idle/core`.  Fired when the user should be warned of an upcoming timeout.|
         * |onIdleStart|Inherited from `\@ng-idle/core`.  Fired when the user has started idling.|
         * |onIdleEnd|Inherited from `\@ng-idle/core`.  Fired when the user breaks idling and is active again.|
         * |onInterrupt|Inherited from `\@ng-idle/core`.  Fired when the user does anything to prevent themselves from idling.|
         * |onLogout|Fired when the user is logged out.|
         */
        this.events = {};
        [
            'onTimeoutWarning',
            'onTimeout',
            'onIdleStart',
            'onIdleEnd',
            'onInterrupt'
        ].forEach((/**
         * @param {?} e
         * @return {?}
         */
        function (e) { return (_this.events[e] = _this.idle[e]); }));
        this.events.onLogout = new EventEmitter();
        this.userObservers = [];
        this.user$ = new Observable((/**
         * @param {?} obs
         * @return {?}
         */
        function (obs) {
            _this.userObservers.push(obs);
        }));
        this.location = window.location;
        this.configure();
        ((/**
         * @return {?}
         */
        function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.isAuthenticated()];
                    case 1:
                        if (!_a.sent()) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.registerToken()];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        }); }))();
    }
    /**
     * @return {?}
     */
    SnAuthService.prototype.configure = /**
     * @return {?}
     */
    function () {
        var _this = this;
        // idle watcher
        this.idle.setIdleName('sn-auth-idle');
        this.idle.setInterrupts([
            new DocumentInterruptSource('keydown mousedown')
        ]);
        this.idle.setIdle(defaultIdleLength);
        this.idle.setTimeout(1);
        this.idle.onTimeout.subscribe((/**
         * @param {?} a
         * @return {?}
         */
        function (a) { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                console.log(new Date().toLocaleTimeString() + " auth-timing out wait random");
                // avoid multiple calls
                setTimeout((/**
                 * @return {?}
                 */
                function () { return __awaiter(_this, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, this.isAuthenticated()];
                            case 1:
                                if (!_a.sent()) return [3 /*break*/, 3];
                                console.log(new Date().toLocaleTimeString() + " auth-timing out logout");
                                return [4 /*yield*/, this.logout()];
                            case 2:
                                _a.sent();
                                _a.label = 3;
                            case 3: return [2 /*return*/];
                        }
                    });
                }); }), Math.floor(Math.random() * 10000));
                return [2 /*return*/];
            });
        }); }));
        this.idle.watch(); // does this need to be reset after an idle?
        // does this get called if another tab logsout? (NO)
        // subsequent calls to get a token don't nudge this either
        // only useful for 'this' tab
        this.okta.$authenticationState.subscribe((/**
         * @param {?} isAuthed
         * @return {?}
         */
        function (isAuthed) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        console.log(new Date().toLocaleTimeString() + " configure authenticationState auth=" + isAuthed);
                        if (!isAuthed) return [3 /*break*/, 2];
                        console.log(new Date().toLocaleTimeString() + " config autstate registerToken");
                        return [4 /*yield*/, this.registerToken()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); }));
        // since okta doesn't notify other tabs
        fromEvent(window, 'storage')
            .pipe(filter((/**
         * @param {?} e
         * @return {?}
         */
        function (e) {
            return e.storageArea === localStorage &&
                e.key === 'okta-token-storage';
        })))
            .subscribe((/**
         * @param {?} e
         * @return {?}
         */
        function (e) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        console.log(new Date().toLocaleTimeString() + " local storage token changed", e);
                        return [4 /*yield*/, this.onLocalStorageChanged()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); }));
    };
    /**
     * @return {?}
     */
    SnAuthService.prototype.onLocalStorageChanged = /**
     * @return {?}
     */
    function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.isAuthenticated()];
                    case 1:
                        if (!_a.sent()) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.registerToken()];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 5];
                    case 3: return [4 /*yield*/, this.logout()];
                    case 4:
                        _a.sent();
                        _a.label = 5;
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * attempt to register a token in this tab and set a timer to extend it
     */
    /**
     * attempt to register a token in this tab and set a timer to extend it
     * @return {?}
     */
    SnAuthService.prototype.registerToken = /**
     * attempt to register a token in this tab and set a timer to extend it
     * @return {?}
     */
    function () {
        return __awaiter(this, void 0, void 0, function () {
            var token, interval_1, claims, actualRefreshTime, e_1;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        console.log(new Date().toLocaleTimeString() + " registerToken");
                        if (this.tokenTimer) {
                            clearTimeout(this.tokenTimer);
                            this.tokenTimer = undefined;
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.getToken()];
                    case 2:
                        token = _a.sent();
                        claims = void 0;
                        claims = JSON.parse(atob(token.split('.')[1]));
                        interval_1 = claims.exp - Math.floor(new Date().getTime() / 1000); // seconds
                        console.log(token);
                        console.log(claims);
                        // debug/diagnostics
                        if (diagnosticShortTokenLife) {
                            if (diagnosticShortTokenLife < interval_1) {
                                interval_1 = diagnosticShortTokenLife;
                            }
                        }
                        console.log("auth_time=" + this.tokenTimeToString(claims.auth_time) + "  iat=" + this.tokenTimeToString(claims.iat) + "  exp=" + this.tokenTimeToString(claims.exp));
                        interval_1 -= tokenRefreshBeforeExpiration;
                        interval_1 += Math.floor(Math.random() * tokenRefreshRandomWindow);
                        if (interval_1 < 0) {
                            interval_1 = 1;
                        }
                        actualRefreshTime = new Date(new Date().getTime() + interval_1 * 1000);
                        console.log(new Date().toLocaleTimeString() + " registerToken setting interval to be " + interval_1 + " " + actualRefreshTime.toLocaleTimeString());
                        this.ngZone.runOutsideAngular((/**
                         * @return {?}
                         */
                        function () {
                            _this.tokenTimer = setTimeout((/**
                             * @return {?}
                             */
                            function () { return __awaiter(_this, void 0, void 0, function () {
                                var e_2;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            this.tokenTimer = undefined;
                                            _a.label = 1;
                                        case 1:
                                            _a.trys.push([1, 3, , 4]);
                                            console.log(new Date().toLocaleTimeString() + " registerToken - timed out, about to renew");
                                            return [4 /*yield*/, this.renewToken()];
                                        case 2:
                                            _a.sent();
                                            console.log(new Date().toLocaleTimeString() + " registerToken - renewed");
                                            return [3 /*break*/, 4];
                                        case 3:
                                            e_2 = _a.sent();
                                            console.log(new Date().toLocaleTimeString() + " registerToken - renew failed", e_2);
                                            return [3 /*break*/, 4];
                                        case 4: return [2 /*return*/];
                                    }
                                });
                            }); }), interval_1 * 1000);
                        }));
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _a.sent();
                        console.log(new Date().toLocaleTimeString() + " registerToken e", e_1);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * @param {?} v
     * @return {?}
     */
    SnAuthService.prototype.tokenTimeToString = /**
     * @param {?} v
     * @return {?}
     */
    function (v) {
        return new Date(v * 1000).toLocaleTimeString();
    };
    /**
     * @return {?}
     */
    SnAuthService.prototype.renewToken = /**
     * @return {?}
     */
    function () {
        return __awaiter(this, void 0, void 0, function () {
            var newAuth, e_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        console.log(new Date().toLocaleTimeString() + " renewToken");
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 5]);
                        return [4 /*yield*/, ((/** @type {?} */ (this))).okta.oktaAuth.tokenManager.renew('idToken')];
                    case 2:
                        newAuth = _a.sent();
                        console.log(new Date().toLocaleTimeString() + " renewToken - token renewed ");
                        return [4 /*yield*/, this.registerToken()];
                    case 3:
                        _a.sent();
                        return [3 /*break*/, 5];
                    case 4:
                        e_3 = _a.sent();
                        console.log(new Date().toLocaleTimeString() + " renewToken - exception ", e_3);
                        this.logout();
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(SnAuthService.prototype, "cfg", {
        /**
         * @ignore
         */
        get: /**
         * @ignore
         * @return {?}
         */
        function () {
            return new config();
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Starts listening for changes to the authentication state in Okta.  When changes
     * are detected, notifies users with the `[user$]{@link SnAuthService#user$}` observable.
     *
     * If you are using the {@link SnAuthGuard}, this is already called for you!
     *
     * @example
     * this.snAuth.watchUser();
     */
    /**
     * Starts listening for changes to the authentication state in Okta.  When changes
     * are detected, notifies users with the `[user$]{\@link SnAuthService#user$}` observable.
     *
     * If you are using the {\@link SnAuthGuard}, this is already called for you!
     *
     * \@example
     * this.snAuth.watchUser();
     * @return {?}
     */
    SnAuthService.prototype.watchUser = /**
     * Starts listening for changes to the authentication state in Okta.  When changes
     * are detected, notifies users with the `[user$]{\@link SnAuthService#user$}` observable.
     *
     * If you are using the {\@link SnAuthGuard}, this is already called for you!
     *
     * \@example
     * this.snAuth.watchUser();
     * @return {?}
     */
    function () {
        var _this = this;
        this.okta.$authenticationState.subscribe((/**
         * @param {?} a
         * @return {?}
         */
        function (a) {
            _this.notifyUser();
        }));
    };
    /**
     * Notifies all subscribers of the `[user$]{@link SnAuthService#user$}` observable
     * with the current state of the user.  If the user is logged in, the payload
     * will be the user details.
     *
     * If you are using the {@link SnAuthGuard}, this is already called for you!
     *
     * @example
     * this.snAuth.notifyUser();
     */
    /**
     * Notifies all subscribers of the `[user$]{\@link SnAuthService#user$}` observable
     * with the current state of the user.  If the user is logged in, the payload
     * will be the user details.
     *
     * If you are using the {\@link SnAuthGuard}, this is already called for you!
     *
     * \@example
     * this.snAuth.notifyUser();
     * @return {?}
     */
    SnAuthService.prototype.notifyUser = /**
     * Notifies all subscribers of the `[user$]{\@link SnAuthService#user$}` observable
     * with the current state of the user.  If the user is logged in, the payload
     * will be the user details.
     *
     * If you are using the {\@link SnAuthGuard}, this is already called for you!
     *
     * \@example
     * this.snAuth.notifyUser();
     * @return {?}
     */
    function () {
        return __awaiter(this, void 0, void 0, function () {
            var user_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.isAuthenticated()];
                    case 1:
                        if (!_a.sent()) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.getUser()];
                    case 2:
                        user_1 = _a.sent();
                        this.userObservers.forEach((/**
                         * @param {?} uo
                         * @return {?}
                         */
                        function (uo) { return uo.next(user_1); }));
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Covers the UI with a loading screen to hide the login process.  Prevents
     * the user from seeing an empty shell application while the login happens.
     * There is purposefully no way to UNcover the UI, as the last step of the login
     * process is to reload the page, which would remove the cover.
     *
     * If you are using the {@link SnAuthGuard}, this is already called for you.
     *
     * @example
     * this.snAuth.cover();
     */
    /**
     * Covers the UI with a loading screen to hide the login process.  Prevents
     * the user from seeing an empty shell application while the login happens.
     * There is purposefully no way to UNcover the UI, as the last step of the login
     * process is to reload the page, which would remove the cover.
     *
     * If you are using the {\@link SnAuthGuard}, this is already called for you.
     *
     * \@example
     * this.snAuth.cover();
     * @return {?}
     */
    SnAuthService.prototype.cover = /**
     * Covers the UI with a loading screen to hide the login process.  Prevents
     * the user from seeing an empty shell application while the login happens.
     * There is purposefully no way to UNcover the UI, as the last step of the login
     * process is to reload the page, which would remove the cover.
     *
     * If you are using the {\@link SnAuthGuard}, this is already called for you.
     *
     * \@example
     * this.snAuth.cover();
     * @return {?}
     */
    function () {
        /** @type {?} */
        var componentRef = this.componentFactoryResolver
            .resolveComponentFactory(SnAuthWorkingComponent)
            .create(this.injector);
        this.appRef.attachView(componentRef.hostView);
        /** @type {?} */
        var cover = (/** @type {?} */ (((/** @type {?} */ (componentRef.hostView)))
            .rootNodes[0]));
        document.body.appendChild(cover);
    };
    /**
     * Set the URI to redirect to after login. Useful for deep-linking, when the
     * user tries to go to a detail page but is not authenticated. After logging in,
     * they will be dumped to the URI specified.
     *
     * If you are using the {@link SnAuthGuard}, this is already called for you!
     *
     * @param path URI to redirect to after login
     * @param queryParams Query params to pass with the redirect URI
     *
     * @example
     * this.snAuth.setRedirectUri('/some/deep/link');
     * this.snAuth.setRedirectUri('/my/dude', { id: 1 });
     */
    /**
     * Set the URI to redirect to after login. Useful for deep-linking, when the
     * user tries to go to a detail page but is not authenticated. After logging in,
     * they will be dumped to the URI specified.
     *
     * If you are using the {\@link SnAuthGuard}, this is already called for you!
     *
     * \@example
     * this.snAuth.setRedirectUri('/some/deep/link');
     * this.snAuth.setRedirectUri('/my/dude', { id: 1 });
     * @param {?} path URI to redirect to after login
     * @return {?}
     */
    SnAuthService.prototype.setRedirectUri = /**
     * Set the URI to redirect to after login. Useful for deep-linking, when the
     * user tries to go to a detail page but is not authenticated. After logging in,
     * they will be dumped to the URI specified.
     *
     * If you are using the {\@link SnAuthGuard}, this is already called for you!
     *
     * \@example
     * this.snAuth.setRedirectUri('/some/deep/link');
     * this.snAuth.setRedirectUri('/my/dude', { id: 1 });
     * @param {?} path URI to redirect to after login
     * @return {?}
     */
    function (path) {
        this.okta.setFromUri(path);
    };
    /**
     * Initiates the login process with Okta.
     *
     * If you are using the {@link SnAuthGuard}, this is already called for you!
     *
     * @example
     * this.snAuth.login();
     */
    /**
     * Initiates the login process with Okta.
     *
     * If you are using the {\@link SnAuthGuard}, this is already called for you!
     *
     * \@example
     * this.snAuth.login();
     * @return {?}
     */
    SnAuthService.prototype.login = /**
     * Initiates the login process with Okta.
     *
     * If you are using the {\@link SnAuthGuard}, this is already called for you!
     *
     * \@example
     * this.snAuth.login();
     * @return {?}
     */
    function () {
        this.okta.loginRedirect();
    };
    /**
     * Logs a user out of the system. Halts the idle listener, logs out of Okta,
     * and refreshes the page. Will bring the user back to the logout screen.
     * If multiple tabs are all logging out at the same time, there may be race
     * conditions that can result in HTTP 404 responses to the HTTP DELETE calls
     * to delete the session (logout). For this reason, this method catches
     * and suppresses HTTP 404 errors.
     *
     * After logout, the method redirects the browser to the `<origin>/logout` URL.
     * It is necessary to have a route path defined to handle the `/logout` URL.
     * Serenity Auth provides a component, `SnAuthLoggedOutComponent`, to handle
     * this route.
     *
     * @example
     * this.snAuth.logout();
     */
    /**
     * Logs a user out of the system. Halts the idle listener, logs out of Okta,
     * and refreshes the page. Will bring the user back to the logout screen.
     * If multiple tabs are all logging out at the same time, there may be race
     * conditions that can result in HTTP 404 responses to the HTTP DELETE calls
     * to delete the session (logout). For this reason, this method catches
     * and suppresses HTTP 404 errors.
     *
     * After logout, the method redirects the browser to the `<origin>/logout` URL.
     * It is necessary to have a route path defined to handle the `/logout` URL.
     * Serenity Auth provides a component, `SnAuthLoggedOutComponent`, to handle
     * this route.
     *
     * \@example
     * this.snAuth.logout();
     * @return {?}
     */
    SnAuthService.prototype.logout = /**
     * Logs a user out of the system. Halts the idle listener, logs out of Okta,
     * and refreshes the page. Will bring the user back to the logout screen.
     * If multiple tabs are all logging out at the same time, there may be race
     * conditions that can result in HTTP 404 responses to the HTTP DELETE calls
     * to delete the session (logout). For this reason, this method catches
     * and suppresses HTTP 404 errors.
     *
     * After logout, the method redirects the browser to the `<origin>/logout` URL.
     * It is necessary to have a route path defined to handle the `/logout` URL.
     * Serenity Auth provides a component, `SnAuthLoggedOutComponent`, to handle
     * this route.
     *
     * \@example
     * this.snAuth.logout();
     * @return {?}
     */
    function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                console.log(new Date().toLocaleTimeString() + " logout");
                this.events.onLogout.emit();
                return [2 /*return*/, this.okta
                        .logout('/logout')
                        .then((/**
                     * @return {?}
                     */
                    function () {
                        console.log('in then for logout, pushing user to logout screen');
                        _this.location.href = _this.location.origin + "/logout";
                    }))
                        .catch((/**
                     * @param {?} e
                     * @return {?}
                     */
                    function (e) {
                        console.log('in error for logout');
                        console.log(JSON.stringify(e, undefined, 2));
                        if (!(e && e.xhr && e.xhr.status === 404)) {
                            return Promise.reject(e);
                        }
                        _this.location.href = _this.location.origin + "/logout";
                    }))];
            });
        });
    };
    /**
     * Gets the authenticated token to use with DaaS requests.
     * @returns token (JWT) for the authenticated user
     *
     * @example
     * const token = await this.snAuth.getToken();
     *
     * @example
     * this.snAuth.getToken(token => console.log(token));
     */
    /**
     * Gets the authenticated token to use with DaaS requests.
     * \@example
     * const token = await this.snAuth.getToken();
     *  /
     * this.snAuth.getToken(token => console.log(token));
     * @return {?} token (JWT) for the authenticated user
     *
     */
    SnAuthService.prototype.getToken = /**
     * Gets the authenticated token to use with DaaS requests.
     * \@example
     * const token = await this.snAuth.getToken();
     *  /
     * this.snAuth.getToken(token => console.log(token));
     * @return {?} token (JWT) for the authenticated user
     *
     */
    function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.okta.getIdToken()];
            });
        });
    };
    /**
     * Determines if the user is currently authenticated.
     * @returns true if they are authenticated, false otherwise
     *
     * @example
     * const isAuthed = await this.snAuth.isAuthenticated();
     *
     * @example
     * this.snAuth.isAuthenticated(isAuthed => console.log(isAuthed));
     */
    /**
     * Determines if the user is currently authenticated.
     * \@example
     * const isAuthed = await this.snAuth.isAuthenticated();
     *  /
     * this.snAuth.isAuthenticated(isAuthed => console.log(isAuthed));
     * @return {?} true if they are authenticated, false otherwise
     *
     */
    SnAuthService.prototype.isAuthenticated = /**
     * Determines if the user is currently authenticated.
     * \@example
     * const isAuthed = await this.snAuth.isAuthenticated();
     *  /
     * this.snAuth.isAuthenticated(isAuthed => console.log(isAuthed));
     * @return {?} true if they are authenticated, false otherwise
     *
     */
    function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        console.log(new Date().toLocaleTimeString() + " isAuthenticated");
                        return [4 /*yield*/, this.okta.isAuthenticated()];
                    case 1: return [2 /*return*/, (/** @type {?} */ ((_a.sent())))];
                }
            });
        });
    };
    /**
     * Fetches information about the logged in user from DaaS as a
     * {@link SnAuthUser}.
     *
     * @returns the logged-in user. If not authenticated, returns a 401.
     *
     * @example
     * const user = await this.snAuth.getUser();
     *
     * @example
     * this.snAuth.getUser().then(user => console.log(user));
     */
    /**
     * Fetches information about the logged in user from DaaS as a
     * {\@link SnAuthUser}.
     *
     * \@example
     * const user = await this.snAuth.getUser();
     *  /
     * this.snAuth.getUser().then(user => console.log(user));
     * @return {?} the logged-in user. If not authenticated, returns a 401.
     *
     */
    SnAuthService.prototype.getUser = /**
     * Fetches information about the logged in user from DaaS as a
     * {\@link SnAuthUser}.
     *
     * \@example
     * const user = await this.snAuth.getUser();
     *  /
     * this.snAuth.getUser().then(user => console.log(user));
     * @return {?} the logged-in user. If not authenticated, returns a 401.
     *
     */
    function () {
        return __awaiter(this, void 0, void 0, function () {
            var claims, snAuthUser;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.isAuthenticated()];
                    case 1:
                        if (!_a.sent()) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.okta.getUser()];
                    case 2:
                        claims = _a.sent();
                        snAuthUser = {
                            firstName: claims.given_name,
                            lastName: claims.family_name,
                            title: "",
                            position: "",
                            email: claims.email,
                            identityProviderId: claims.sub,
                            partyMemberId: "",
                            dataLineageId: ""
                        };
                        return [2 /*return*/, snAuthUser];
                    case 3: return [2 /*return*/, Promise.reject(401)];
                }
            });
        });
    };
    SnAuthService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    SnAuthService.ctorParameters = function () { return [
        { type: OktaAuthService },
        { type: Idle },
        { type: HttpClient },
        { type: ComponentFactoryResolver },
        { type: ApplicationRef },
        { type: Injector },
        { type: NgZone }
    ]; };
    return SnAuthService;
}());
if (false) {
    /**
     * Event emitters for all auth-related events
     *
     * |Event|Description|
     * |----|----|
     * |onTimeout|Inherited from `\@ng-idle/core`.  Fired on session timeout, when the user will be logged out.|
     * |onTimeoutWarning|Inherited from `\@ng-idle/core`.  Fired when the user should be warned of an upcoming timeout.|
     * |onIdleStart|Inherited from `\@ng-idle/core`.  Fired when the user has started idling.|
     * |onIdleEnd|Inherited from `\@ng-idle/core`.  Fired when the user breaks idling and is active again.|
     * |onInterrupt|Inherited from `\@ng-idle/core`.  Fired when the user does anything to prevent themselves from idling.|
     * |onLogout|Fired when the user is logged out.|
     * @type {?}
     */
    SnAuthService.prototype.events;
    /**
     * Observable that notifies subscribers whenever the state of the user is changed (login or logout).
     * @type {?}
     */
    SnAuthService.prototype.user$;
    /**
     * Used to proxy the window.location global
     * @ignore
     * @type {?}
     */
    SnAuthService.prototype.location;
    /**
     * Reference to the sessionTimer setTimeout which will force the user
     * to logout when the Okta session ends.
     * @ignore
     * @type {?}
     */
    SnAuthService.prototype.tokenTimer;
    /**
     * @ignore
     * @type {?}
     * @private
     */
    SnAuthService.prototype.userObservers;
    /**
     * @type {?}
     * @private
     */
    SnAuthService.prototype.okta;
    /**
     * @type {?}
     * @private
     */
    SnAuthService.prototype.idle;
    /**
     * @type {?}
     * @private
     */
    SnAuthService.prototype.http;
    /**
     * @type {?}
     * @private
     */
    SnAuthService.prototype.componentFactoryResolver;
    /**
     * @type {?}
     * @private
     */
    SnAuthService.prototype.appRef;
    /**
     * @type {?}
     * @private
     */
    SnAuthService.prototype.injector;
    /**
     * @type {?}
     * @private
     */
    SnAuthService.prototype.ngZone;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Guards any authentication-required pages in an application.  Handles all authentication
 * processes, while hiding the UI with a loading screen.
 *
 * If the user is NOT authenticated, this will send the user to the Okta login screen.  After
 * the user is logged in, they will be redirected to where they were.
 *
 * If the user IS authenticated, this will wire up all of the idle listening, timeout handling, and display the application.
 */
var SnAuthGuard = /** @class */ (function () {
    function SnAuthGuard(auth) {
        this.auth = auth;
        this.auth.notifyUser();
        this.auth.watchUser();
    }
    /**
     * @param {?} route
     * @param {?} state
     * @return {?}
     */
    SnAuthGuard.prototype.canActivate = /**
     * @param {?} route
     * @param {?} state
     * @return {?}
     */
    function (route, state) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.auth.isAuthenticated()];
                    case 1:
                        // check if already logged in
                        if (_a.sent()) {
                            return [2 /*return*/, true];
                        }
                        // cover the UI
                        console.log('covering the ui');
                        this.auth.cover();
                        // login
                        this.auth.setRedirectUri(state.url);
                        this.auth.login();
                        return [2 /*return*/, false];
                }
            });
        });
    };
    SnAuthGuard.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root'
                },] }
    ];
    /** @nocollapse */
    SnAuthGuard.ctorParameters = function () { return [
        { type: SnAuthService }
    ]; };
    /** @nocollapse */ SnAuthGuard.ɵprov = ɵɵdefineInjectable({ factory: function SnAuthGuard_Factory() { return new SnAuthGuard(ɵɵinject(SnAuthService)); }, token: SnAuthGuard, providedIn: "root" });
    return SnAuthGuard;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    SnAuthGuard.prototype.auth;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var SnAuthError = /** @class */ (function () {
    function SnAuthError(oAuthError) {
        console.log('oAuthError');
        console.log(oAuthError);
        this.code = oAuthError.errorCode;
        this.message = oAuthError.errorSummary;
        this.setCapabilities({
            retry: true
        });
    }
    /**
     * @return {?}
     */
    SnAuthError.prototype.getCode = /**
     * @return {?}
     */
    function () {
        return this.code;
    };
    /**
     * @return {?}
     */
    SnAuthError.prototype.getMessage = /**
     * @return {?}
     */
    function () {
        return this.message;
    };
    /**
     * @return {?}
     */
    SnAuthError.prototype.getName = /**
     * @return {?}
     */
    function () {
        return this.code
            .split('_')
            .map((/**
         * @param {?} s
         * @return {?}
         */
        function (s) { return s.charAt(0).toUpperCase() + s.substring(1); }))
            .join(' ');
    };
    /**
     * @param {?} capabilities
     * @return {?}
     */
    SnAuthError.prototype.setCapabilities = /**
     * @param {?} capabilities
     * @return {?}
     */
    function (capabilities) {
        this.capabilities = capabilities;
    };
    /**
     * @return {?}
     */
    SnAuthError.prototype.getCapabilities = /**
     * @return {?}
     */
    function () {
        return this.capabilities;
    };
    return SnAuthError;
}());
if (false) {
    /** @type {?} */
    SnAuthError.prototype.code;
    /** @type {?} */
    SnAuthError.prototype.message;
    /** @type {?} */
    SnAuthError.prototype.capabilities;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var SnAuthErrorAccessDenied = /** @class */ (function (_super) {
    __extends(SnAuthErrorAccessDenied, _super);
    function SnAuthErrorAccessDenied(oAuthError) {
        var _this = _super.call(this, oAuthError) || this;
        _this.message =
            'You do not have the required permissions to use this application.';
        _this.setCapabilities({
            logout: true,
            retry: true
        });
        return _this;
    }
    return SnAuthErrorAccessDenied;
}(SnAuthError));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function SnAuthErrorCapabilities() { }
if (false) {
    /** @type {?|undefined} */
    SnAuthErrorCapabilities.prototype.logout;
    /** @type {?|undefined} */
    SnAuthErrorCapabilities.prototype.retry;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function OAuthError() { }
if (false) {
    /** @type {?} */
    OAuthError.prototype.errorCode;
    /** @type {?} */
    OAuthError.prototype.errorSummary;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Authentication callback component used in the Okta redirect handshake.  This
 * is consumed by {\@link SnAuthGuard} to finalize the Okta login process.  It simply
 * tells the Okta library to start handling the authentication, which will eventually
 * navigate away from this component!
 */
var SnAuthCallbackComponent = /** @class */ (function () {
    function SnAuthCallbackComponent(okta, ngZone) {
        this.okta = okta;
        this.ngZone = ngZone;
        /**
         * Determines whether the switch used for running E2Es in conjunction with Serenity
         * Authentication has been enabled.
         * @return boolean True if the ngZone has been enabled for use in E2Es, false otherwise
         */
        this.e2esEnabled = (/**
         * @return {?}
         */
        function () {
            return localStorage.getItem('sn-auth-e2e-enabled') === 'true';
        });
    }
    /**
     * @return {?}
     */
    SnAuthCallbackComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.e2esEnabled()) return [3 /*break*/, 1];
                        this.ngZone.runOutsideAngular((/**
                         * @return {?}
                         */
                        function () { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, this.handleAuthentication()];
                                    case 1:
                                        _a.sent();
                                        return [2 /*return*/];
                                }
                            });
                        }); }));
                        return [3 /*break*/, 3];
                    case 1: return [4 /*yield*/, this.handleAuthentication()];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Invokes Okta authentication method for parsing tokens from callback URL.
     * If an error occurs, captures error into a variable.
     */
    /**
     * Invokes Okta authentication method for parsing tokens from callback URL.
     * If an error occurs, captures error into a variable.
     * @return {?}
     */
    SnAuthCallbackComponent.prototype.handleAuthentication = /**
     * Invokes Okta authentication method for parsing tokens from callback URL.
     * If an error occurs, captures error into a variable.
     * @return {?}
     */
    function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                /**
                 * Handles the response from Okta and parses tokens.
                 */
                return [2 /*return*/, this.okta
                        .handleAuthentication()
                        .then((/**
                     * @return {?}
                     */
                    function () {
                        /**
                         * Navigate back to the saved uri, or root of application.
                         * @type {?}
                         */
                        var fromUri = _this.okta.getFromUri();
                        window.location.replace(fromUri);
                    }))
                        .catch((/**
                     * @param {?} e
                     * @return {?}
                     */
                    function (e) {
                        _this.error = _this.errorHandler(e);
                    }))];
            });
        });
    };
    /**
     * Converts an OAuthError into a Serenity Auth error. If there isn't
     * a custom error handler for the specified OAuthError, it falls back
     * to the generic {@link SnAuthError}.
     * @param e OAuthError to handle
     */
    /**
     * Converts an OAuthError into a Serenity Auth error. If there isn't
     * a custom error handler for the specified OAuthError, it falls back
     * to the generic {\@link SnAuthError}.
     * @private
     * @param {?} e OAuthError to handle
     * @return {?}
     */
    SnAuthCallbackComponent.prototype.errorHandler = /**
     * Converts an OAuthError into a Serenity Auth error. If there isn't
     * a custom error handler for the specified OAuthError, it falls back
     * to the generic {\@link SnAuthError}.
     * @private
     * @param {?} e OAuthError to handle
     * @return {?}
     */
    function (e) {
        switch (e.errorCode) {
            case 'access_denied':
                return new SnAuthErrorAccessDenied(e);
            default:
                return new SnAuthError(e);
        }
    };
    SnAuthCallbackComponent.decorators = [
        { type: Component, args: [{
                    selector: 'sn-auth-callback',
                    template: "\n        <div *ngIf=\"!(error || e2esEnabled())\">\n            <sn-auth-working></sn-auth-working>\n        </div>\n        <div *ngIf=\"error\"><sn-auth-error [error]=\"error\"></sn-auth-error></div>\n    "
                }] }
    ];
    /** @nocollapse */
    SnAuthCallbackComponent.ctorParameters = function () { return [
        { type: OktaAuthService },
        { type: NgZone }
    ]; };
    return SnAuthCallbackComponent;
}());
if (false) {
    /**
     * Holds the error if an error happens during login
     * @type {?}
     */
    SnAuthCallbackComponent.prototype.error;
    /**
     * Determines whether the switch used for running E2Es in conjunction with Serenity
     * Authentication has been enabled.
     * \@return boolean True if the ngZone has been enabled for use in E2Es, false otherwise
     * @type {?}
     */
    SnAuthCallbackComponent.prototype.e2esEnabled;
    /**
     * @type {?}
     * @private
     */
    SnAuthCallbackComponent.prototype.okta;
    /**
     * @type {?}
     * @private
     */
    SnAuthCallbackComponent.prototype.ngZone;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @ignore
 */
var SnAuthErrorComponent = /** @class */ (function () {
    function SnAuthErrorComponent(auth) {
        this.auth = auth;
        this.auth = auth;
        this.location = window.location;
    }
    /**
     * Logs the user out. If they can't be logged out for any reason, throws them
     * back to the location origin.
     */
    /**
     * Logs the user out. If they can't be logged out for any reason, throws them
     * back to the location origin.
     * @return {?}
     */
    SnAuthErrorComponent.prototype.logout = /**
     * Logs the user out. If they can't be logged out for any reason, throws them
     * back to the location origin.
     * @return {?}
     */
    function () {
        var _this = this;
        return this.auth.logout().catch((/**
         * @return {?}
         */
        function () {
            _this.location.href = _this.location.origin;
        }));
    };
    /**
     * Retries the login.
     */
    /**
     * Retries the login.
     * @return {?}
     */
    SnAuthErrorComponent.prototype.retry = /**
     * Retries the login.
     * @return {?}
     */
    function () {
        this.auth.login();
    };
    SnAuthErrorComponent.decorators = [
        { type: Component, args: [{
                    selector: 'sn-auth-error',
                    template: "\n        <div class=\"cover\">\n            <div class=\"frown\"><i class=\"far fa-frown-open\"></i></div>\n            <h1 class=\"my-5\">{{ error.getName() }}</h1>\n            <div class=\"message\">{{ error.message }}</div>\n            <div class=\"actions mt-5\">\n                <a (click)=\"logout()\" *ngIf=\"error.capabilities.logout\"\n                    >Logout</a\n                >\n                <a (click)=\"retry()\" *ngIf=\"error.capabilities.retry\">Retry</a>\n            </div>\n        </div>\n    ",
                    styles: ["\n            .cover {\n                position: fixed;\n                width: 100%;\n                height: 100%;\n                left: 0;\n                top: 0;\n                background: #007bff;\n                z-index: 2147483647;\n                display: flex;\n                justify-content: center;\n                align-items: center;\n                color: #fff;\n                flex-direction: column;\n            }\n\n            .frown {\n                font-size: 150px;\n            }\n\n            .message {\n                background: #3395ff;\n                font-size: 20px;\n                padding: 20px;\n                max-width: 50%;\n            }\n\n            .actions a {\n                font-size: 20px;\n                padding-left: 15px;\n                padding-right: 15px;\n                cursor: pointer;\n            }\n        "]
                }] }
    ];
    /** @nocollapse */
    SnAuthErrorComponent.ctorParameters = function () { return [
        { type: SnAuthService }
    ]; };
    SnAuthErrorComponent.propDecorators = {
        error: [{ type: Input }]
    };
    return SnAuthErrorComponent;
}());
if (false) {
    /**
     * Error to display
     * @type {?}
     */
    SnAuthErrorComponent.prototype.error;
    /**
     * Used to proxy the window.location global
     * @ignore
     * @type {?}
     */
    SnAuthErrorComponent.prototype.location;
    /**
     * @type {?}
     * @private
     */
    SnAuthErrorComponent.prototype.auth;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var config$1 = forwardRef((/**
 * @return {?}
 */
function () { return ConfigProvider.config; }));
var SnAuthInterceptor = /** @class */ (function () {
    function SnAuthInterceptor() {
    }
    /**
     * @param {?} request
     * @param {?} next
     * @return {?}
     */
    SnAuthInterceptor.prototype.intercept = /**
     * @param {?} request
     * @param {?} next
     * @return {?}
     */
    function (request, next) {
        /** @type {?} */
        var c = new config$1();
        /** @type {?} */
        var oktaStorage = window.localStorage.getItem('okta-token-storage');
        try {
            oktaStorage = JSON.parse(oktaStorage);
        }
        catch (e) {
            oktaStorage = undefined;
        }
        /** @type {?} */
        var t = oktaStorage &&
            ((/** @type {?} */ (oktaStorage))).idToken &&
            ((/** @type {?} */ (oktaStorage))).idToken.idToken;
        /** @type {?} */
        var headerValues = {
            Authorization: request.headers.get('Authorization') || "Bearer " + t,
            Audience: request.headers.get('Audience') ||
                c.audience ||
                'Generic Serenity Project',
            'x-source-description': request.headers.get('x-source-description') ||
                c.sourceDescription ||
                'Generic Serenity Project',
            'x-correlation-id': request.headers.get('x-correlation-id') || this.uuidv4()
        };
        request = request.clone({
            headers: request.headers
                .set('Authorization', headerValues.Authorization)
                .set('Audience', headerValues.Audience)
                .set('x-source-description', headerValues['x-source-description'])
                .set('x-correlation-id', headerValues['x-correlation-id'])
        });
        return next.handle(request);
    };
    // https://stackoverflow.com/questions/105034/create-guid-uuid-in-javascript
    // tslint:disable
    // https://stackoverflow.com/questions/105034/create-guid-uuid-in-javascript
    // tslint:disable
    /**
     * @private
     * @return {?}
     */
    SnAuthInterceptor.prototype.uuidv4 = 
    // https://stackoverflow.com/questions/105034/create-guid-uuid-in-javascript
    // tslint:disable
    /**
     * @private
     * @return {?}
     */
    function () {
        return (((/** @type {?} */ ([1e7]))) + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (/**
         * @param {?} c
         * @return {?}
         */
        function (c) {
            return (c ^
                (crypto.getRandomValues(new Uint8Array(1))[0] &
                    (15 >> (c / 4)))).toString(16);
        }));
    };
    SnAuthInterceptor.decorators = [
        { type: Injectable }
    ];
    return SnAuthInterceptor;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Authentication component displayed after a user's Okta session has ended. This
 * is intended to be registered with a `/logout` route by an application using
 * Serenity Auth.
 */
var SnAuthLoggedOutComponent = /** @class */ (function () {
    function SnAuthLoggedOutComponent() {
    }
    SnAuthLoggedOutComponent.decorators = [
        { type: Component, args: [{
                    selector: 'sn-auth-logged-out',
                    template: "\n        <div class=\"cover\">\n            <div>\n                You have been logged out. Goodbye!\n                <div class=\"mt-4\">\n                    <a class=\"login btn btn-primary\" href=\"/\">Login</a>\n                </div>\n            </div>\n        </div>\n    ",
                    styles: ["\n            .cover {\n                position: fixed;\n                width: 100%;\n                height: 100%;\n                left: 0;\n                top: 0;\n                color: #fff !important;\n                background: #007bff;\n                z-index: 2147483647;\n                display: flex;\n                justify-content: center;\n                align-items: center;\n                text-align: center;\n                font-size: 50px !important;\n                line-height: 50px !important;\n            }\n\n            a.login {\n                font-size: 34px !important;\n                line-height: 50px !important;\n                padding: 8px 25px !important;\n                background-color: #0af !important;\n                border-color: #0af !important;\n                border-radius: 8px !important;\n            }\n\n            a.login:hover {\n                background-color: #0091d9 !important;\n                border-color: #0091d9 !important;\n            }\n\n            a.btn {\n                height: auto !important;\n            }\n        "]
                }] }
    ];
    return SnAuthLoggedOutComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @param {?} appSettingsService
 * @return {?}
 */
function oktaConfigFactory(appSettingsService) {
    console.log('in okta config factory at:', new Date().toLocaleString());
    console.log('getting app settings service configs');
    /** @type {?} */
    var config = appSettingsService.getSettings();
    console.log(config);
    /** @type {?} */
    var oktaConfig = __assign(__assign({}, config.oktaConfiguration), { pkce: false, tokenManager: {
            autoRenew: false,
            storage: 'localStorage'
        } });
    return oktaConfig;
}
// tslint:disable-next-line:variable-name
/** @type {?} */
var SnOktaConfigProvider = {
    provide: OKTA_CONFIG,
    useFactory: oktaConfigFactory,
    deps: [AppSettingsService]
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
// tslint:disable-next-line:prefer-const
/** @type {?} */
var cfProvider;
var SnAuthModule = /** @class */ (function () {
    function SnAuthModule(configProvider) {
        this.configProvider = configProvider;
        cfProvider = this.configProvider;
    }
    /**
     * @param {?} config
     * @return {?}
     */
    SnAuthModule.setConfig = /**
     * @param {?} config
     * @return {?}
     */
    function (config) {
        cfProvider.setConfig(config);
    };
    SnAuthModule.decorators = [
        { type: NgModule, args: [{
                    imports: [HttpClientModule, CommonModule, OktaAuthModule],
                    providers: [
                        SnAuthService,
                        AppSettingsService,
                        SnAuthGuard,
                        SnAuthInterceptor,
                        ConfigProvider,
                        SnOktaConfigProvider,
                        Keepalive
                    ],
                    declarations: [
                        SnAuthWorkingComponent,
                        SnAuthCallbackComponent,
                        SnAuthLoggedOutComponent,
                        SnAuthErrorComponent
                    ],
                    exports: [
                        SnAuthWorkingComponent,
                        SnAuthCallbackComponent,
                        SnAuthLoggedOutComponent
                    ],
                    entryComponents: [SnAuthWorkingComponent]
                },] }
    ];
    /** @nocollapse */
    SnAuthModule.ctorParameters = function () { return [
        { type: ConfigProvider }
    ]; };
    return SnAuthModule;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    SnAuthModule.prototype.configProvider;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function SnAuthUser() { }
if (false) {
    /** @type {?} */
    SnAuthUser.prototype.firstName;
    /** @type {?} */
    SnAuthUser.prototype.lastName;
    /** @type {?} */
    SnAuthUser.prototype.title;
    /** @type {?} */
    SnAuthUser.prototype.position;
    /** @type {?} */
    SnAuthUser.prototype.email;
    /** @type {?} */
    SnAuthUser.prototype.identityProviderId;
    /** @type {?} */
    SnAuthUser.prototype.partyMemberId;
    /** @type {?} */
    SnAuthUser.prototype.dataLineageId;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function SnAuthEvents() { }
if (false) {
    /**
     * Inherited from `\@ng-idle/core`.  Fired on session timeout, when the user will be logged out.
     * @type {?|undefined}
     */
    SnAuthEvents.prototype.onTimeout;
    /**
     * Inherited from `\@ng-idle/core`.  Fired when the user should be warned of an upcoming timeout.
     * @type {?|undefined}
     */
    SnAuthEvents.prototype.onTimeoutWarning;
    /**
     * Inherited from `\@ng-idle/core`.  Fired when the user has started idling.
     * @type {?|undefined}
     */
    SnAuthEvents.prototype.onIdleStart;
    /**
     * Inherited from `\@ng-idle/core`.  Fired when the user breaks idling and is active again.
     * @type {?|undefined}
     */
    SnAuthEvents.prototype.onIdleEnd;
    /**
     * Inherited from `\@ng-idle/core`.  Fired when the user does anything to prevent themselves from idling.
     * @type {?|undefined}
     */
    SnAuthEvents.prototype.onInterrupt;
    /**
     * Fired when the user is logged out.
     * @type {?|undefined}
     */
    SnAuthEvents.prototype.onLogout;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @param {?} initService
 * @param {?} injector
 * @return {?}
 */
function snPreInitServiceFactory(initService, injector) {
    return (/**
     * @return {?}
     */
    function () {
        return new Promise((/**
         * @param {?} resolve
         * @return {?}
         */
        function (resolve) {
            return injector
                .get(LOCATION_INITIALIZED, Promise.resolve(undefined))
                .then((/**
             * @return {?}
             */
            function () { return resolve(initService.onInit()); }));
        }));
    });
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { SnAuthCallbackComponent, SnAuthGuard, SnAuthInterceptor, SnAuthLoggedOutComponent, SnAuthModule, SnAuthService, SnAuthWorkingComponent, SnOktaConfigProvider, oktaConfigFactory, snPreInitServiceFactory, AppSettingsService as ɵa, ConfigProvider as ɵb, SnAuthErrorComponent as ɵc };
//# sourceMappingURL=insight-serenity-auth.js.map
